import React from "react";
import { Col } from "reactstrap";
import { FormField } from "./FormField";
import { FormSectionType } from './types';;

export const FormColumn = ({title, size, inputs}: FormSectionType) => {
    return (
        <Col {...size} className="px-4">
            {title && <h4 className="card-title mb-4">{title}</h4>}
            {inputs.map(input => 
                <FormField key={input.title} {...input} />)
            }
        </Col>
    );
};
